import RecordRTC from 'recordrtc'
import i18n from "@/i18n/i18n.js";
import { MessageBox } from "element-ui";
import { ClientChat } from '@/api/clientChat';
const DEVICE_NOT_FOUND_INFO = i18n.t("VIDEO.LAYOUT.DEVICE_NOT_FOUND_INFO");
const DEVICE_NOT_FOUND = i18n.t("VIDEO.LAYOUT.DEVICE_NOT_FOUND");

const state = {
  clientChatRoomId: '',
  currentMessageId: '',     // 當下進行視訊的 messageId
  agentRTC: null,          // RTC 本體
  recorder: null,     // 錄影
  chunks: [],              // 錄影檔
  videoReady: false,       // 是否正在進行 Video call
  videoDisplay: false,     // 是否正在顯示鏡頭
  screenShareOn: false,    // 是否正在分享螢幕
  remoteStream: null,      // 遠端視訊串流
  localStream: null,       // 本地視訊串流
  tracks: {
    localAudioTrack: null,
    localVideoTrack: null,
    remoteAudioTrack: null,
    remoteVideoTrack: null
  },
  screenShareStream: null, // 螢幕分享串流
  videoSender: null,       // 分享中的視訊
  audioSender: null,       // 分享中的音訊
  videoOptions: {          // 分享視訊鏡頭參數
    audio: false,
    video: false,
  },
  screenShareOptions: {
    video: { cursor: "never", enabled: true }, // 視訊資訊的設定
    audio: true,                // 是否包含音訊資訊 
    logicalSurface: false       // 設定是否包含所選螢幕外區域的一些資訊 
  }
};

const actions = {
  setMessageId({ commit }, payload) {
    commit('setMessageId', payload)
  },
  toggleDisplay({ commit }, payload) {
    commit("toggleDisplay", payload);
  },
  async toggleShareScreen({ state, commit, dispatch }, payload) {

    if (payload) { // 開啟

      let options = state.screenShareOptions
      try {
        let stream = await navigator.mediaDevices.getDisplayMedia(options);
        let videoTrack = stream.getVideoTracks()[0];

        state.videoSender.replaceTrack(videoTrack);

        // 偵聽關閉事件
        videoTrack.addEventListener('ended', () => {
          dispatch('shareWebcam')
          commit('toggleScreenShare', false)
        })

        commit('setScreenShareStream', stream)
        commit('toggleScreenShare', true)
        dispatch('handlelocalVideo', { stream, options })

      } catch (err) {
        console.error("Error: " + err);
      }
    } else { // 關閉串流 切換為 webcam
      state.screenShareStream.getTracks()
        .forEach(track => track.stop())
      dispatch('shareWebcam')
      commit('toggleScreenShare', false)
    }



  },
  shareWebcam({ state, dispatch }) {
    var stream = state.localStream
    var videoTrack = stream.getVideoTracks()[0];
    state.videoSender.replaceTrack(videoTrack);

    dispatch('handlelocalVideo', { stream, options: state.videoOptions })

  },
  async initLocalStream({ commit, dispatch }, clientChatRoomId) {
    const initialOptions = {
      audio: true, //聲音開關
      video: {
        enabled: false,
        width: { ideal: 1280 },
        height: { ideal: 720 },
        frameRate: { ideal: 30, max: 60 }, //偵率
        facingMode: "user",
      },
    };
    commit('setClientChatRoomId', clientChatRoomId)
    commit("setVideoOptions", initialOptions);
    console.log("2. 初始化本地 Stream!");
    let stream = null;
    try {
      stream = await navigator.mediaDevices.getUserMedia(initialOptions);

      commit("setLocalStream", stream);
      dispatch('handlelocalVideo', { stream, options: initialOptions })
      dispatch("initRTCPeerConnection", { stream, clientChatRoomId });



    } catch (error) {
      MessageBox({
        title: DEVICE_NOT_FOUND,
        message: DEVICE_NOT_FOUND_INFO,
        type: 'error',
        iconClass: 'el-icon-info',
        confirmButtonText: 'OK',
        center: true
      });
      console.log(`catch: [${error.code}] ${error.name} - ${error.message}`);
    }
  },
  async initRTCPeerConnection({ rootState, commit, dispatch }, payload) {
    let { stream, clientChatRoomId } = payload
    console.log("3. init RTCPeerConnection!");
    const AgentRTC = new RTCPeerConnection({
      // 配置ICE服務器
      iceServers: [
        { urls: "stun:stun.stunprotocol.org:3478" },
        { urls: "stun:stun.l.google.com:19302" },
        {
          urls: "turn:openrelay.metered.ca:443?transport=tcp",
          username: "openrelayproject",
          credential: "openrelayproject",
        },
      ],
    });
    // 增加本地流
    console.log("4. AddTrack!");
    // AgentRTC.addStream(stream);
    stream.getTracks().forEach(track => {
      // console.log(`[A]Agent add local "${track.kind}" track.`)
      let sender = AgentRTC.addTrack(track, stream)
      commit('setSender', {
        kind: track.kind,
        sender: sender
      })
    })
    // 創建應答連接
    AgentRTC.onicecandidate = (e) => {
      if (e.candidate) {
        // console.log('on icecandidate', e.candidate);
        rootState.clientChat.connection.invoke("sendSignalToCustomer", {
          ClientChatRoomId: clientChatRoomId,
          Signal: JSON.stringify({ candidate: e.candidate }),
        });
      } else {
        // console.log('收集 candidates 完畢!')
        // Null candidate means we are done collecting candidates.
        rootState.clientChat.connection.invoke("sendSignalToCustomer", {
          ClientChatRoomId: clientChatRoomId,
          Signal: JSON.stringify({ candidate: null }),
        });
      }
    };
    // 監聽 ICE 連接狀態
    AgentRTC.oniceconnectionstatechange = (e) => {
      let { iceConnectionState } = e.target
      console.log("ICE Connection state change => ", iceConnectionState);
      if (iceConnectionState == 'connected') {
        dispatch('startRecording')
      }
    };
    // 接收 stream
    AgentRTC.ontrack = (e) => {
      console.log(`[A]Agent add remote "${e.track.kind}" track from client`)
      // 接收 reomote Stream
      let remoteVideo = document.querySelector("#remoteVideo");
      if (remoteVideo.srcObject !== e.streams[0]) {
        remoteVideo.srcObject = e.streams[0];
      }
      remoteVideo.onloadedmetadata = function (e) {
        remoteVideo.play();
      };
      if (!state.remoteStream) {
        commit("setRemoteStream", e.streams[0]);
      } else {
        let stream = state.remoteStream
        stream.addTrack(e.track)
        commit("setRemoteStream", stream);
      }
    };

    const offer = await AgentRTC.createOffer(); // 建立offer
    AgentRTC.setLocalDescription(offer); // 本地存下自己的Offer

    rootState.clientChat.connection.invoke("sendSignalToCustomer", {
      ClientChatRoomId: clientChatRoomId,
      Signal: JSON.stringify({ sdp: offer }),
    });
    // console.log("sendSignalToCustomer(offer)!");
    commit("setAgentRTC", AgentRTC);
  },
  receiveSignal({ rootState, state }, payload) {
    let signal = JSON.parse(payload.signal);
    let { clientChatRoomId } = payload;
    const AgentRTC = state.agentRTC;

    // console.log('6.receiveSignal', clientChatRoomId, signal);

    if (signal.sdp) {
      AgentRTC.setRemoteDescription(
        new RTCSessionDescription(signal.sdp),
        () => {
          if (AgentRTC.remoteDescription.type == "offer") {
            // agent 端目前應該只會收到 answer , 不會收到 offer (Agent 端發起 offer)
            AgentRTC.createAnswer().then((answer) => {
              AgentRTC.setLocalDescription(answer);

              rootState.clientChat.connection.invoke("sendSignalToCustomer", {
                ClientChatRoomId: clientChatRoomId,
                Signal: JSON.stringify({ sdp: answer }),
              });
            });
          } else if (AgentRTC.remoteDescription.type == "answer") {
            console.log("WebRTC: remote Description type answer");
          }
        }
      );
    } else if (signal.candidate) {
      AgentRTC.addIceCandidate(new RTCIceCandidate(signal.candidate));
    } else {
      AgentRTC.addIceCandidate(null);
    }
  },
  hangup({ state, commit, dispatch }) {
    if (state.videoReady) {
      state.agentRTC.close();
      state.localStream.getTracks().forEach((track) => {
        track.stop();
      });
      commit("cleanAgentRTC");
    }
    if (state.recorder) {
      dispatch('stopRecording')
    }
  },
  handlelocalVideo(context, { stream, options }) {
    // 控制本地Video player (正式上線不會顯示在畫面上)
    // console.log('handlelocalVideo:', stream, options);
    let localVideo = document.querySelector("#localVideo");
    if (localVideo.srcObject !== stream) {
      localVideo.srcObject = stream
      let videoTrack = localVideo.srcObject.getVideoTracks()[0]
      let audioTrack = localVideo.srcObject.getAudioTracks()[0]
      videoTrack ? videoTrack.enabled = options.video.enabled : ''
      audioTrack ? audioTrack.enabled = options.audio : ''
    }
    localVideo.onloadedmetadata = function (e) {
      localVideo.play();
    };
  },
  startRecording({ state, commit, getters }) {
    const env = process.env.NODE_ENV
    let recorder = state.recorder
    let stream = getters.destStream
    const options = {
      type: 'video',
      mimeType: 'video/webm;codecs=vp8,vp9',
      timeSlice: 30000, // 30s 切一支錄影檔
      disableLogs: true, // 開發者工具不顯示log
      videoBitsPerSecond: 512000, // default 128000 (低畫質)
      frameInterval: 1,
      ondataavailable: async function (blob) {
        // 補充：1MB = size:1,000,000位元組
        if (env == 'development') {
          console.log('取得錄影資料', `Tracks:[${stream.getTracks().length}] msgId:${state.currentMessageId}`, blob);
        } else {
          // production mode 才上傳到 server
          let formData = new FormData();

          formData.append('MessageId', state.currentMessageId)
          formData.append("VideoFiles", blob);
          formData.append("ClientChatRoomId", state.clientChatRoomId);

          await ClientChat.UploadRecoredFiles(formData).then(res => {
            if (res.status == 200) {
              console.log(`File uploaded. Size:${res.data[0].size}`);
            }

          }).catch(err => {
            console.log('catch', err);
          })
        }
      },

    }

    if (!recorder) {
      console.log('startRecording.');
      recorder = RecordRTC(stream, options)
      recorder.startRecording();
      commit('setRecorder', recorder)
    }

  },
  stopRecording({ state, commit }) {
    const env = process.env.NODE_ENV
    const recorder = state.recorder
    recorder.stopRecording(function () {
      console.log('stopRecording.');
      if (env == 'development') {
        // 本地開發環境執行下載測試(不上傳到server)
        let blob = recorder.getBlob();
        let url = URL.createObjectURL(blob)
        let downloadLink = document.createElement("a");
        downloadLink.target = "_blank";
        downloadLink.rel = "noreferrer noopener";
        downloadLink.style.display = "none";
        downloadLink.download = 'record test';
        downloadLink.href = url;
        downloadLink.click();
      }
      commit('setRecorder', null) //clear recorder
    });

  }
};

const mutations = {
  setMessageId(state, payload) {
    state.currentMessageId = payload
  },
  setClientChatRoomId(state, payload) {
    state.clientChatRoomId = payload
  },
  setVideoOptions(state, payload) {
    state.videoOptions = payload;
  },
  toggleDisplay(state, payload) {
    state.videoDisplay = payload;
  },
  toggleAudio(state, payload) {
    state.videoOptions.audio = payload;
    state.localStream.getAudioTracks()[0].enabled = payload;
  },
  toggleVideo(state, payload) {
    state.videoOptions.video.enabled = payload;
    state.localStream.getVideoTracks()[0].enabled = payload;
  },
  toggleScreenShare(state, payload) {
    state.screenShareOn = payload;
  },
  setAgentRTC(state, payload) {
    state.agentRTC = payload;
    state.videoReady = true;
    state.videoDisplay = true;
  },
  setRemoteStream(state, stream) {
    state.remoteStream = stream;
    state.tracks.remoteAudioTrack = stream.getAudioTracks()[0]
    state.tracks.remoteVideoTrack = stream.getVideoTracks()[0]
  },
  setLocalStream(state, stream) {
    state.localStream = stream;
    state.tracks.localAudioTrack = stream.getAudioTracks()[0]
    state.tracks.localVideoTrack = stream.getVideoTracks()[0]
  },
  setScreenShareStream(state, payload) {
    state.screenShareStream = payload;
  },
  setSender(state, payload) {
    let { kind, sender } = payload
    if (kind == 'video') {
      state.videoSender = sender
    } else if (kind == 'audio') {
      state.audioSender = sender
    }
  },
  setRecorder(state, payload) {
    state.recorder = payload
  },
  setChunk(state, payload) {
    state.chunks.push(payload)
  },
  cleanAgentRTC(state) {
    state.agentRTC = null;
    state.remoteStream = null;
    state.localStream = null;
    state.tracks = {
      localAudioTrack: null,
      localVideoTrack: null,
      remoteAudioTrack: null,
      remoteVideoTrack: null
    }
    state.videoReady = false;
    state.videoDisplay = false;
  },
};

const getters = {
  destStream(state) {
    // 最終欲錄製的 stream
    const ac = new AudioContext();
    const rs = state.remoteStream
    const ls = state.localStream
    const remoteAudioTrack = rs ? rs.getAudioTracks()[0] : null
    const remoteVideoTrack = rs ? rs.getVideoTracks()[0] : null
    const localAudioTrack = ls ? ls.getAudioTracks()[0] : null

    const remoteAudioStream = new MediaStream();
    const localAudioStream = new MediaStream();

    if (remoteAudioTrack) remoteAudioStream.addTrack(remoteAudioTrack)
    if (localAudioTrack) localAudioStream.addTrack(localAudioTrack)

    // remoteAudioStream 與 localAudioStream 一定要有 audio track，否則這裡會報錯！
    let audioIn_01, audioIn_02
    if (remoteAudioStream.getAudioTracks().length) {
      audioIn_01 = ac.createMediaStreamSource(remoteAudioStream);
    }
    if (localAudioStream.getAudioTracks().length) {
      audioIn_02 = ac.createMediaStreamSource(localAudioStream);
    }

    // Mixing
    const dest = ac.createMediaStreamDestination();
    if (audioIn_01) audioIn_01.connect(dest)
    if (audioIn_02) audioIn_02.connect(dest)

    // 再加入remote videoTrack
    if (remoteVideoTrack) dest.stream.addTrack(remoteVideoTrack);
    return dest.stream
  },
  videoOptions: (state) => {
    return state.videoOptions;
  },
  ready: (state) => {
    return state.videoReady;
  },
  display: (state) => {
    return state.videoDisplay;
  },
  screenShareOn: (state) => {
    return state.screenShareOn;
  },
  remoteStream: (state) => {
    return state.remoteStream;
  },
  localStream: (state) => {
    return state.localStream;
  },
  chunksSize: (state) => {
    let sizes = state.chunks.map(c => {
      return c.size
    })
    let total = sizes.reduce((a, b) => {
      return a + b
    }, 0)

    var size = (total / (1024 * 1024)).toFixed(2); // MB
    return size + "MB"
  },
  recorderStatus: (state) => {
    if (state.recorder) {
      return state.recorder.state
    } else {
      return ''
    }

  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
